module.exports = __webpack_public_path__ + "static/media/tornado.d77a26b2.svg";